import type {FC} from 'react';
import {memo} from 'react';

import IconUserPlusSVG from '@yourcoach/shared/assets/icons/user-plus.svg';

interface Props {
  customClass?: string;
  height?: string;
  width?: string;
}

const IconUserPlus: FC<Props> = ({
  customClass = '',
  height = '100%',
  width = '100%',
}) => {
  return (
    <IconUserPlusSVG
      className={`${customClass}`}
      fill="#819AA9"
      height={width}
      width={height}
    />
  );
};

export default memo(IconUserPlus);
